import { addToChainAfter, replaceInChain } from "@insite/client-framework/HandlerCreator";
import { ApiHandlerDiscreteParameter, HasOnError, HasOnSuccess } from "@insite/client-framework/HandlerCreator";
import { UpdateAccountApiParameter } from "@insite/client-framework/Services/AccountService";
import { API_URL_CURRENT_FRAGMENT } from "@insite/client-framework/Services/ApiService";
import { AddCartLinesApiParameter } from "@insite/client-framework/Services/CartService";
import { getCurrentAccountState } from "@insite/client-framework/Store/Data/Accounts/AccountsSelector";
import { getCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import {
    chain,
    GetCurrentAccount,
    PopulateApiParameter,
} from "@insite/client-framework/Store/Pages/AccountSettings/Handlers/SaveCurrentAccount";
import { PopulateAddLineCollectionApiParameter } from "@insite/client-framework/Store/Pages/SavedOrderDetails/Handlers/PlaceOrder";
import { AccountModel, CartLineModel } from "@insite/client-framework/Types/ApiModels";

export interface UserShowProductBrandImagesInterface extends HasOnSuccess {
    showProductBrandImages: boolean;
}

type HandlerType = ApiHandlerDiscreteParameter<
    HasOnError<string> & UserShowProductBrandImagesInterface,
    UpdateAccountApiParameter,
    AccountModel,
    { account: AccountModel }
>;

export const ExtendedPopulateApiParameter: HandlerType = props => {
    props.apiParameter = {
        ...props.apiParameter,
        account: {
            ...props.apiParameter.account,
            properties: {
                ...props.apiParameter.account.properties,
                showProductBrandImages: props.parameter.showProductBrandImages ? "true" : "false",
            },
        },
    };
};

addToChainAfter(chain, PopulateApiParameter, ExtendedPopulateApiParameter);

export const GetCustomCurrentAccount: HandlerType = props => {
    const currentPage = getCurrentPage(props.getState()).type;
    const account =
        currentPage !== "AccountSettingsPage"
            ? getCurrentAccountState(props.getState()).value
            : props.getState().pages.accountSettings.editingAccount;

    if (!account) {
        throw new Error("There was no current account when we are trying to save the current account");
    }
    props.account = account;
};

replaceInChain(chain, GetCurrentAccount, GetCustomCurrentAccount);
